import { useEffect, useState } from 'react';
import useDetectionStore from '../store/useDetectionStore';

/** How long the Classes panel stays highlighted after a nudge. */
const NUDGE_MS = 1800;

/**
 * True for a moment after the user tried to draw without a label class.
 *
 * Replaces the modal "No class selected" alert: the highlight appears on the
 * Classes panel and the canvas callout — where the user actually has to act —
 * and fades on its own, so nothing has to be dismissed between attempts.
 */
const useClassAttention = () => {
  const classAttentionAt = useDetectionStore((state) => state.classAttentionAt);
  const [isNudging, setIsNudging] = useState(false);

  useEffect(() => {
    if (!classAttentionAt) return undefined;
    setIsNudging(true);
    const timer = setTimeout(() => setIsNudging(false), NUDGE_MS);
    return () => clearTimeout(timer);
  }, [classAttentionAt]);

  return isNudging;
};

export default useClassAttention;
